var map = {
	"./demo/tenon-light.woff": 54,
	"./demo/tenon-light.woff2": 55,
	"./demo/tenon-medium.woff": 56,
	"./demo/tenon-medium.woff2": 57,
	"./demo/tenon-regular.woff": 58,
	"./demo/tenon-regular.woff2": 59,
	"./licensed/tenon-italic.woff": 60,
	"./licensed/tenon-italic.woff2": 61,
	"./licensed/tenon-light.woff": 62,
	"./licensed/tenon-light.woff2": 63,
	"./licensed/tenon-lightitalic.woff": 64,
	"./licensed/tenon-lightitalic.woff2": 65,
	"./licensed/tenon-medium.woff": 66,
	"./licensed/tenon-medium.woff2": 67,
	"./licensed/tenon-regular.woff": 68,
	"./licensed/tenon-regular.woff2": 69,
	"./space-grotesk-medium.woff2": 70,
	"./tenon-italic.woff": 71,
	"./tenon-italic.woff2": 72,
	"./tenon-light.woff": 73,
	"./tenon-light.woff2": 74,
	"./tenon-lightitalic.woff": 75,
	"./tenon-lightitalic.woff2": 76,
	"./tenon-medium.woff": 77,
	"./tenon-medium.woff2": 78,
	"./tenon-regular.woff": 79,
	"./tenon-regular.woff2": 80
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;